// extracted by mini-css-extract-plugin
export var productImage = "_nu-1";
export var viewLink = "_nu-2";
export var wishlistItem = "_nu-0";